export const CATEGORIA_UNIDADE = {
    PUBLICA_LOCAL: 0,
    PACTUADA: 1,
    PRIVADA: 2
};
export const SITUACAO = {
    INATIVA: 0,
    ATIVA: 1
};
export const TIPO_CONSULTA = {
    PRIMEIRA: 0,
    RETORNO: 1,
    LOCAL: 2
};
export const SEXO = {
    AMBOS: 0,
    MASCULINO: 1,
    FEMININO: 2
};
export const ESTADO_CIVIL = {
    SOLTEIRO: 0,
    CASADO: 1,
    DESQUITADO: 2,
    DIVORCIADO: 3,
    VIUVO: 4
};
export const TIPO_CERTIDAO = {
    NASCIMENTO: 0,
    CASAMENTO: 1,
    SEPARACAO: 2,
};
export const TIPO_ATENDIMENTO = {
    INDIVIDUAL: 0,
    AGRUPADO: 1,
};
export const TIPO_AGRUPAMENTO = {
    BIOQUIMICA: 0,
    OFTALMOLOGIA: 1,
};
export const COMPLEXIDADE = {
    BAIXA: 0,
    MEDIA: 1,
    ALTA: 2,
};
export const TIPO_FINANCIAMENTO = {
    ASSISTENCIA_FARMACEUTICA_E_MAC: 0,
    FAEC: 1,
    INCENTIVO: 2,
    MAC: 3,
    VIGILANCIA: 4,
    AB: 5,
    ASSISTENCIA_FARMACEUTICA: 6,
};
export const SITUACAO_SOLICITACAO = {
    MARCADA: 1,
    EM_REGULACAO: 2,
    REGULADA: 3,
    NEGATIVADA: 4,
    INFORMACAO_PENDENTE: 5,
    INFORMACAO_ADICIONAL: 6,
    CONFIRMADA: 7,
    CANCELADA: 8,
    FALTA: 9,
    REALIZADA: 10,
};
export const SITUACAO_SOLICITACAO_ANTIGA = {
	EM_ANALISE: 1,
	APROVADA: 2,
	CONFIRMADA: 3,
	NEGADA: 4,
	EM_PERICIA: 5,
	CANCELADA: 6,
	REALIZADA: 7,
	FALTA: 8,
	EM_SUPERVISAO: 9,
	SUPERVISIONADO: 10,
	EM_EXTRAPOLACAO: 11,
	TFD: 12,
	FALTA_AUTOMATICA: 18,
};
export const FORM_ATENDIMENTOS = {
    CRIAR: 0,
    BLOQUEAR: 1
};
export const TIPO_UNIDADE = {
    UNIDADE_BASICA: 1,
    HOSPITAL: 2
};
export const TIPO_CONTRATO = {
    SOLICITANTE: 0,
    PRESTADOR: 1
};



// WEBPACK FOOTER //
// ./src/constants.js